import axios from 'axios';

const generateSpreadsheetPradaItens = async (
  token: string,
  unidadeId: number | string,
  processo: string,
  url: string,
) => {
  let message = null;

  try {
    const response = await axios.get(`${url}?processo=${encodeURIComponent(processo)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], `Prada Itens - ${processo}.xlsx`, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const fileUrl = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
    } else {
      message = await response.data.text();
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.data) {
        try {
          message = await error.response.data.text();
        } catch (_e) {
          message = 'Erro inesperado ao gerar a planilha.';
        }
      } else {
        message = 'Erro inesperado ao gerar a planilha.';
      }
    } else {
      message = 'Erro inesperado ao gerar a planilha.';
    }
  }

  return message;
};

export { generateSpreadsheetPradaItens };